import InitialState from "./InitialState";

const FormReducer = (state, { payload, type }) => {
    switch (type) {
        case 'ADD_GOOD':
            return {
                ...state,
                goods: [
                    ...state.goods,
                    {
                        good: '',
                        photos: null,
                        description: ''
                    }
                ],
            }
        case 'REMOVE_GOOD':
            return {
                ...state,
                goods: [
                    ...state.goods.filter(function (good, index) {
                        return index !== payload
                    }),
                ],
            }
        case 'UPDATE_ISSUE':
            return {
                ...state,
                form: {
                    ...payload
                },
            }

        case 'UPDATE_GOODS':
            return {
                ...state,
                goods: payload,
            }

        case 'CHANGE_GDPR':
            return {
                ...state,
                gdpr: payload,
            }
        case "FORM_SENDING":
            return {
                ...state,
                sending: true,
                sent: false,
                errors: {}
            }
        case "FORM_SENT":
            return {
                ...state,
                sending: false,
                sent: true,
                errors: {}
            }
        case "VALIDATION_ERROR":
            return {
                ...state,
                sending: false,
                sent: false,
                errors: payload
            }
        case 'CHANGE_TYPE':
            return {
                ...InitialState,
                formType: payload,
            }
        case "CANCEL_LOADING":
            return {
                ...state,
                sending: false,
            }
        case "HIDE_MODAL":
            let prevFormType = state.formType;
            return {
                ...InitialState,
                prevFormType
            }
        default:
            return state
    }
};

export default FormReducer;
